export default {
  small: [
    'alert',
    'amex',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'clear',
    'comment',
    'cross',
    'delivery',
    'edit',
    'event',
    'eye-closed',
    'eye-open',
    'hours',
    'info-concierge',
    'list-view',
    'location-drop-pin',
    'mastercard',
    'movies',
    'question-mark',
    'offer',
    'payment',
    'refine',
    'search',
    'shopping-cart',
    'star',
    'tick',
    'tick-circle',
    'user',
    'visa',
    'phone',
  ],
  medium: [
    'afterpay',
    'alert',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'car',
    'centre-map',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'click-and-collect',
    'comment',
    'copy',
    'cross',
    'delivery',
    'download',
    'edit',
    'email',
    'event',
    'eye-closed',
    'eye-open',
    'facebook',
    'gift-cards',
    'grid-view',
    'hamburger',
    'hours',
    'info-concierge',
    'instagram',
    'list-view',
    'location-drop-pin',
    'offer',
    'padlock-locked',
    'padlock-unlocked',
    'parking',
    'payment',
    'phone',
    'search',
    'settings',
    'shopping-cart',
    'store',
    'target',
    'tick',
    'tick-circle',
    'trash-bin',
    'twitter',
    'user',
    'water',
    'website',
    'westfield-direct',
    'westfield-w',
    'wireless',
  ],
  large: [
    'alert',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'atm',
    'bike-repair-station',
    'bus',
    'car',
    'car-wash',
    'centre-map',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'community-rooms',
    'concierge',
    'delivery',
    'department-store',
    'digital-gift-card',
    'dry-cleaning',
    'electrical-vehicle-charging-station',
    'email',
    'escalator-down',
    'escalator',
    'escalator-up',
    'family',
    'fashion-styling',
    'fashion',
    'floral',
    'food-and-drink',
    'gift-card',
    'gift-cards',
    'handsfree-shopping',
    'health-and-beauty',
    'info-concierge',
    'interior-styling',
    'justice-of-the-peace',
    'kids-playworld',
    'lift',
    'location-drop-pin',
    'location-marker',
    'luggage-storage',
    'map-directions',
    'mobility-scooter-hire',
    'movies',
    'music',
    'padlock-locked',
    'padlock-unlocked',
    'parents-room',
    'parking',
    'retailsite',
    'returns',
    'search',
    'shopping-cart',
    'smartscreen',
    'superscreen',
    'sustainability',
    'stairs-down',
    'stairs-up',
    'store',
    'taxi',
    'tick',
    'tick-circle',
    'tickless-parking',
    'toilet-accessible',
    'toilet-female',
    'toilet-male',
    'toilet',
    'train',
    'tram',
    'uber-pickup',
    'undercover-parking',
    'unmetered-parking',
    'valet-parking',
    'wallet',
    'westfield-app',
    'westfield-plus',
    'westfield-suite',
    'westfield-direct',
    'westfield-direct-service',
    'whats-happening',
    'wifi',
    'phone',
  ],
}
